import { render, staticRenderFns } from "./AppTextField.vue?vue&type=template&id=36cba088"
var script = {}
import style0 from "./AppTextField.vue?vue&type=style&index=0&id=36cba088&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports